import { useNavigate } from 'react-router-dom';
import DashboardAppService from '../../../../application/platform/scp/dashboard/dashboard-app-service';
import { ACTION_TYPES, useDashboardDispatch, useDashboardState } from "./dashboard-context";
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useDashboardController = () => {
    const navigate = useNavigate();
    const { showLoading } = useBaseLayout();
    const dispatch = useDashboardDispatch();
    const { selectedYear, startDate, endDate } = useDashboardState();

    async function loadData() {
        try {
            showLoading({ open: true });
            dispatch({ type: ACTION_TYPES.setLoading, payload: true });

            const dashboardData = await DashboardAppService.getOverview({
                year: selectedYear,
                startDate: startDate,
                endDate: endDate
            });

            dispatch({
                type: ACTION_TYPES.setDashboardData,
                payload: dashboardData
            });

            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            showLoading({ open: false });
        } catch (error) {
            console.error(error);
            dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            showLoading({ open: false });
        }
    }

    function handleYearChange(year: number) {
        dispatch({
            type: ACTION_TYPES.setSelectedYear,
            payload: year
        });
    }

    function handleStartDateChange(date?: Date) {
        dispatch({
            type: ACTION_TYPES.setStartDate,
            payload: date
        });
    }

    function handleEndDateChange(date?: Date) {
        dispatch({
            type: ACTION_TYPES.setEndDate,
            payload: date
        });
    }

    function navigateToPurchases() {
        navigate('/compras-licitacoes');
    }

    function navigateToContracts() {
        navigate('/contratos');
    }

    function navigateToPriceRegistrations() {
        navigate('/atas-registro-preco');
    }

    return {
        loadData,
        handleYearChange,
        handleStartDateChange,
        handleEndDateChange,
        navigateToPurchases,
        navigateToContracts,
        navigateToPriceRegistrations
    };
}
